import * as React from "react"
import type { IconProps } from './../../models/icon';

export function CheckmarkIcon({
    width = 24,
    height = 24,
    className = '',
    title = '',
    ...props
  }: IconProps) {
    return (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    className={className}
    {...props}
  >
    {title && <title>{title}</title>}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.267}
      d="m19.6 6-9.067 11.333L6 13.933"
    />
  </svg>
)}
